import { Component, ViewChild, inject } from '@angular/core';
import { IonInput, ModalController } from '@ionic/angular';

import { colors } from '../../../_shared/data/colors';
import { ToastService } from '../../../_core/services/toast.service';

@Component({
  standalone: false,
    selector: 'app-color-picker',
    templateUrl: './color-picker.component.html',
    styleUrls: ['./color-picker.component.scss'],
})
export class ColorPickerComponent {
    private modalController = inject(ModalController);
    @ViewChild('color') colorInput: IonInput;

    colors = colors;
    selectedColor = '#f44336';

    constructor( private toast: ToastService,){}

    selectColor(color: string) {
        const isValid = /^#([A-Fa-f0-9]{6})$/.test(color);
        if(isValid){
            this.modalController.dismiss(color);
        } else {
            this.toast.presentToast('Invalid hex color code.');
        }
    }

    changeColor(ev) {
        this.selectedColor = ev.detail.value;
        if (this.colorInput) this.colorInput.value = this.selectedColor;
    }

    async close() {
        await this.modalController.dismiss();
    }

}
